module.exports = __webpack_public_path__ + "static/media/OtherDroppedTiles.89913a26.jpg";